// extracted by mini-css-extract-plugin
export default {"tabs__nav":"Tabs_tabs__nav__CuWPB","tabs__content":"Tabs_tabs__content__drLPX"};